import App from "./components/App";
import { AppContainer } from "react-hot-loader";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
//import { ThemeProvider } from "@fluentui/react";
import { FluentProvider, Theme, webDarkTheme, webLightTheme } from "@fluentui/react-components";
import * as React from "react";
import * as ReactDOM from "react-dom";

/* global document, Office, module, require */

initializeIcons();

let isOfficeInitialized = false;

const title = "EVE Online Excel Add-in";
const customLightTheme: Theme = {
  ...webLightTheme,
  fontFamilyBase: "ShentoxRegular",
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const customDarkTheme: Theme = {
  ...webDarkTheme,
  fontFamilyBase: "ShentoxRegular",
};

const render = (Component: any) => {
  ReactDOM.render(
    <AppContainer>
      <FluentProvider theme={customLightTheme}>
        <Component title={title} isOfficeInitialized={isOfficeInitialized} />
      </FluentProvider>
    </AppContainer>,
    document.getElementById("container")
  );
};

/* Render application after Office initializes */
Office.onReady(() => {
  isOfficeInitialized = true;
  render(App);
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    render(NextApp);
  });
}
